import { render, staticRenderFns } from "./MintalMesPrdFieldOpcConfigEdit.vue?vue&type=template&id=f9d70b82&"
import script from "./MintalMesPrdFieldOpcConfigEdit.vue?vue&type=script&lang=js&"
export * from "./MintalMesPrdFieldOpcConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports